import React from 'react'
import styled from 'styled-components'
import Icon from 'components/Icon.v2'

export const Button = styled.button`
  position: absolute;
  border: none;
  right: 20px;
  top: 20px;
  z-index: 1000;
  width: 20px;
  height: 20px;
  padding: 0;
  color: white;

  > div {
    width: 20px;
    height: 20px;
  }
`

export const CloseButton = styled(({ onClick, ...p }) => (
  <Button onClick={onClick}>
    <Icon type="close" {...p} />
  </Button>
))``

export const VenueHeader = styled.div`
  height: 210px;
  position: relative;
  background: white;
`

export const VenueContent = styled.div`
  padding: 30px;
`

export const HostAvatar = styled.div`
  position: absolute;
  top: 75%;
  left: 50%;
  border: 1px solid ${p => p.theme.colors.white};
  border-radius: 50%;
  height: 0;
  width: 100px;
  padding-top: 25.5%;
  transform: translate(-50%, -50px);
  background-size: cover;
  background-position: center;
  background-color: white;
`

export const Logo = styled.img`
  height: 35px;
  width: 51px;
`
